export default function contactForm() {
    const form = document.querySelector("[data-contact-form]");
    if (!form) return;

    const tsInput = form.querySelector("[data-contact-ts]");
    if (tsInput) tsInput.value = String(Date.now());

    const status = form.querySelector(".contact-form__status");
    const submit = form.querySelector(".contact-form__submit");

    form.addEventListener("submit", async (event) => {
        event.preventDefault();
        if (submit) submit.disabled = true;
        if (status) status.textContent = "Sending…";

        const payload = Object.fromEntries(new FormData(form));

        try {
            const response = await fetch(form.action, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });
            if (response.ok) {
                form.reset();
                if (tsInput) tsInput.value = String(Date.now());
                if (status) status.textContent = "Thanks — we'll be in touch.";
            } else {
                const body = await response.json().catch(() => ({}));
                if (status) status.textContent = body.error || "Something went wrong. Please try again.";
            }
        } catch {
            if (status) status.textContent = "Network error. Please try again.";
        } finally {
            if (submit) submit.disabled = false;
        }
    });
}
